// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Page-specific styles for Login */

/* Simple login and register screens */
.auth-page-simple {
  min-height: 100svh;
  padding: 1rem;
  display: grid;
  place-items: center;
  background: var(--cream);
}
.auth-card-simple {
  width: min(100%, 520px);
  padding: 1.25rem;
}
.auth-card-simple .brand { margin-bottom: 1.5rem; }
.auth-card-simple h1 { margin: .45rem 0; font-size: clamp(2rem, 8vw, 3rem); line-height: 1; }
.auth-card-simple > p { color: var(--muted); margin-bottom: 1.25rem; }
.auth-card-simple .form-card { margin-top: 1rem; }
.auth-card-simple .form-label { margin-bottom: .4rem; }
.auth-card-simple .form-control { margin-bottom: 1rem; }
.auth-card-simple .btn { min-height: 50px; }

.address-card .btn-link { cursor: pointer; }

@media (min-width: 768px) {
  .auth-card-simple { padding: 2rem; }
}
`, "",{"version":3,"sources":["webpack://./src/css/Login.css"],"names":[],"mappings":"AAAA,mCAAmC;;AAEnC,sCAAsC;AACtC;EACE,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,wBAAwB;AAC1B;AACA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;AACA,2BAA2B,qBAAqB,EAAE;AAClD,uBAAuB,gBAAgB,EAAE,iCAAiC,EAAE,cAAc,EAAE;AAC5F,wBAAwB,mBAAmB,EAAE,sBAAsB,EAAE;AACrE,+BAA+B,gBAAgB,EAAE;AACjD,gCAAgC,oBAAoB,EAAE;AACtD,kCAAkC,mBAAmB,EAAE;AACvD,yBAAyB,gBAAgB,EAAE;;AAE3C,0BAA0B,eAAe,EAAE;;AAE3C;EACE,oBAAoB,aAAa,EAAE;AACrC","sourcesContent":["/* Page-specific styles for Login */\n\n/* Simple login and register screens */\n.auth-page-simple {\n  min-height: 100svh;\n  padding: 1rem;\n  display: grid;\n  place-items: center;\n  background: var(--cream);\n}\n.auth-card-simple {\n  width: min(100%, 520px);\n  padding: 1.25rem;\n}\n.auth-card-simple .brand { margin-bottom: 1.5rem; }\n.auth-card-simple h1 { margin: .45rem 0; font-size: clamp(2rem, 8vw, 3rem); line-height: 1; }\n.auth-card-simple > p { color: var(--muted); margin-bottom: 1.25rem; }\n.auth-card-simple .form-card { margin-top: 1rem; }\n.auth-card-simple .form-label { margin-bottom: .4rem; }\n.auth-card-simple .form-control { margin-bottom: 1rem; }\n.auth-card-simple .btn { min-height: 50px; }\n\n.address-card .btn-link { cursor: pointer; }\n\n@media (min-width: 768px) {\n  .auth-card-simple { padding: 2rem; }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
